export default __webpack_public_path__ + "static/bar-presentation-793aad5b69ef49b1d6b98f4377c8e735.png";